import { render, staticRenderFns } from "./ProTip.vue?vue&type=template&id=7ddccdd9&scoped=true&"
import script from "./ProTip.vue?vue&type=script&lang=js&"
export * from "./ProTip.vue?vue&type=script&lang=js&"
import style0 from "./ProTip.vue?vue&type=style&index=0&id=7ddccdd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddccdd9",
  null
  
)

export default component.exports